module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/ant-pic.a28309d1.png";